export const initialise = () => {
    const widgets = document.querySelectorAll('.attrax-list-widget')

    viewAllMove(widgets)
}

const viewAllMove = (widgets) => {
    widgets.forEach(widget => {
        const readMore = widget.querySelector('.attrax-list-widget__readmore')
        const tabs = widget.querySelector('.attrax-list-widget__tabs')
        if (readMore && tabs) {
            tabs.appendChild(readMore)
        }
    })
}